if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          // Custom Code: Thumbnails direction
          direction: window.innerWidth >= 1100 ? this.querySelector('[id^="GalleryThumbnails"]').getAttribute('data-slider-direction') || 'horizontal' : 'horizontal',
        };

        // Custom Code: Resize observer to set thumbnails direction
        window.addEventListener('resize', () => {
          if(window.innerWidth >= 1100) {
           this.elements.direction = this.querySelector('[id^="GalleryThumbnails"]').getAttribute('data-slider-direction') || 'horizontal';
          } else {
            this.elements.direction = 'horizonal';
          }
        });
        
        this.mql = window.matchMedia('(min-width: 750px)');

        this.initGalleryLabelVisibility();

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      initGalleryLabelVisibility() {
        const updateLabel = () => {
          const activeMedia = this.elements.viewer?.querySelector('.product__media-item.is-active');
          this.updateGalleryLabelVisibility(activeMedia);
        };

        updateLabel();

        this.elements.viewer?.querySelectorAll('.product__media-item').forEach((item) => {
          const observer = new MutationObserver(updateLabel);
          observer.observe(item, { attributes: true, attributeFilter: ['class'] });
        });
      }

      updateGalleryLabelVisibility(activeMedia) {
        const labelContainer = this.elements.viewer?.querySelector('.product-gallery-labels');
        if (!labelContainer) return;

        const showLabel = activeMedia?.dataset.showGalleryLabel === 'true';
        labelContainer.classList.toggle('hidden', !showLabel);
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement?.dataset.mediaId}"]`
        );
        if(thumbnail) {
          this.setActiveThumbnail(thumbnail);
        }
        if (event.detail.currentElement) {
          this.updateGalleryLabelVisibility(event.detail.currentElement);
        }
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }

        if(mediaId.indexOf('quickadd-') > -1 && !document.querySelector(`[data-media-id="${mediaId}"]`)) {
          // Custom Code: Set active gellery media for quick add when the gallery media data-media-id is changed (without quickadd- prefix)
          let prevButton = this.elements.viewer.querySelector('button[name="previous"]');
          let nextButton = this.elements.viewer.querySelector('button[name="next"]');
          let quickGallery = this.elements.viewer.querySelectorAll('[data-media-id]')
          quickGallery.forEach((element) => {
            element.classList.remove('is-active');
            element.setAttribute('aria-current', true);
            element?.querySelector('.magnifier-open[data-fancybox]')?.setAttribute('tabindex', '-1');
            element?.querySelector('.image-magnify-hover')?.setAttribute('tabindex', '-1');
          });
          let activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId.replace('quickadd-', '')}"]`) || this.elements.viewer.querySelector('[data-media-id]');
          activeMedia?.classList?.add('is-active');
          activeMedia?.removeAttribute('aria-current');
          activeMedia?.querySelector('.magnifier-open[data-fancybox]')?.setAttribute('tabindex', '0');
          activeMedia?.querySelector('.image-magnify-hover')?.setAttribute('tabindex', '0');

          // init buttons state
          quickGallery[0].classList.contains('is-active') ? prevButton.setAttribute('disabled', 'disabled') : prevButton.removeAttribute('disabled');
          quickGallery[quickGallery.length - 1].classList.contains('is-active') ? nextButton.setAttribute('disabled', 'disabled') : nextButton.removeAttribute('disabled');

          // mutations observer to set buttons state
          let observerTarget = this.elements.viewer.querySelectorAll('.product__media-list li') || [];
          let productMediaObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.attributeName === 'class') {
                let firtNodeState = observerTarget[0]?.classList.contains('is-active');
                let lastNodeState = observerTarget[observerTarget.length - 1]?.classList.contains('is-active');
                if (firtNodeState) {
                  prevButton.setAttribute('disabled', 'disabled');
                } else {
                  prevButton.removeAttribute('disabled');
                }
                if (lastNodeState) {
                  nextButton.setAttribute('disabled', 'disabled');
                } else {
                  nextButton.removeAttribute('disabled');
                }
              }
            });
          });
          // 开始观察
          productMediaObserver.observe(observerTarget[0], {attributes: true, attributeFilter: ['class']});
          productMediaObserver.observe(observerTarget[observerTarget.length - 1], {attributes: true, attributeFilter: ['class']});
        } else {
          // Default Code: Set active gallery media
          this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]').forEach((element) => {
            element.classList.remove('is-active');
            element.setAttribute('aria-hidden', true);
            element?.querySelector('.magnifier-open[data-fancybox]')?.setAttribute('tabindex', '-1');
            element?.querySelector('.image-magnify-hover')?.setAttribute('tabindex', '-1');
          });
          activeMedia?.classList?.add('is-active');
          activeMedia?.removeAttribute('aria-hidden');
          activeMedia?.querySelector('.magnifier-open[data-fancybox]')?.setAttribute('tabindex', '0');
          activeMedia?.querySelector('.image-magnify-hover')?.setAttribute('tabindex', '0');
        }

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          // Custom Code: Add judgment conditions - control scroll to image(not in view) only for screen sizes below 1000px
          if(window.innerWidth <= 1000) {
            const activeMediaRect = activeMedia.getBoundingClientRect();
            // Don't scroll if the image is already in view
            if (activeMediaRect.top > -0.5) return;
            // Custom Code: Add judgment conditions - Determine whether it is a quick add pop-up window trigger event
            if(this.closest('.quick-add-modal')) {
              let inner_window = this.closest('.quick-add-modal').querySelector('.quick-add-modal__content');
              const top = activeMediaRect.top + inner_window.scrollY;
              inner_window.scrollTo({ top: top, behavior: 'smooth' });
            } else {
              const top = activeMediaRect.top + window.scrollY;
              window.scrollTo({ top: top, behavior: 'smooth' });
            }
          }
        });
        this.playActiveMedia(activeMedia);
        this.updateGalleryLabelVisibility(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail?.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        // if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;  // 注释掉这句：可控制点击任意缩略图，保持滑动置顶

        if(this.elements.direction === 'vertical') {
          this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop });
        } else {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
